import { SystemVariables } from '../../services/system-variables/models/system-variables.model';

export class SetSystemVariables {
  static readonly type = '[SYSTEM VARIABLES] Set system variables';

  constructor(public payload: SystemVariables) {
  }
}
